import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import React from 'react';

import "./style.css";

import { AuthLayout } from '../../Components/Layout/AuthLayout';
import CustomButton from '../../Components/CustomButton';
import CustomInput from "../../Components/CustomInput"
import { base_url } from '../../Api/base_url';


const AdminLogin = () => {
    const navigate = useNavigate()

    const [formData, setFormData] = useState();


    useEffect(() => {
        document.title = 'Task Manager | Login';
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        const formDataMethod = new FormData();
        formDataMethod.append('username', formData?.username);
        formDataMethod.append('password', formData?.password);
        console.log(formData)
        document.querySelector('.loaderBox').classList.remove("d-none");

        const apiUrl = `${base_url}/api/auth/login`;


        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                body: formDataMethod
            });

            if (response.ok) {
                const responseData = await response.json();
                localStorage.setItem('login', responseData?.token);
                localStorage.setItem('userID', responseData?.id);
                localStorage.setItem('userInfo', responseData?.user?.username);
                localStorage.setItem('userEmail', responseData?.user?.email);
                localStorage.setItem('userRole', responseData?.user?.role);
                localStorage.setItem('roleID', responseData?.role);
                console.log('Login Response:', responseData);
                document.querySelector('.loaderBox').classList.add("d-none");
                navigate('/dashboard')
                
            } else {
                document.querySelector('.loaderBox').classList.add("d-none");
                alert('Invalid Credentials')

                console.error('Login failed');
            }
        } catch (error) {
            document.querySelector('.loaderBox').classList.add("d-none");
            console.error('Error:', error);
        }
    };


    return (
        <>
            <AuthLayout  authPara='Login into your Account'>
                <form onSubmit={handleSubmit}>
                    <CustomInput
                        label='Username'
                        required
                        id='userEmail'
                        type='text'
                        placeholder='Enter Your Username'
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        onChange={(event) => {
                            setFormData({ ...formData, username: event.target.value });
                            console.log(event.target.value);
                        }}
                    />
                    <CustomInput
                        label='Password'
                        required
                        id='pass'
                        type='password'
                        placeholder='Enter Password'
                        labelClass='mainLabel'
                        inputClass='mainInput'
                        onChange={(event) => {
                            setFormData({ ...formData, password: event.target.value });
                            console.log(event.target.value);
                        }}
                    />
                    <div className="d-flex align-items-baseline justify-content-between mt-1">
                        <div className="checkBox">
                            <input type="checkbox" name="rememberMe" id="rememberMe" className='me-1' />
                            <label htmlFor="rememberMe" className='fw-semibold'>Remember Me</label>
                        </div>
                        {/* <Link to={'/forget-password'} className='text-dark text-decoration-underline'>Forget Password?</Link> */}
                    </div>
                    <div className="mt-4 text-center">
                        <CustomButton variant='primaryButton' text='Login' type='submit' />
                    </div>
                </form>
            </AuthLayout>
        </>
    )
}


export default AdminLogin
